import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import CookieConsent from './ui/CookieConsent.jsx';
import '../styles/Layout.css';

const Layout = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  return (
    <div className="layout">
      <main className={`main-content ${!isHomePage ? 'page-with-header' : ''}`}>
        <Header />
        <Outlet />
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default Layout;
